/* eslint-disable @next/next/no-img-element */
import { useCallback, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Box, Button, DialogContent, Typography } from '@mui/material'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'

import {
  COMPANY_STATUS,
  DISCONNECTED_UNKNOWN_NUMBER_TOAST_ID,
  UTILS,
} from '@/shared/constants'
import useWhatsappApi from '@/hooks/useWhatsAppApi'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { RootState } from '@/store'
import {
  setIsConnected,
} from '@/store/features/whatsappSlice'

interface Props {
  open: boolean
  onClose: () => void
}

export default function ConnectToWhatsappDialog(props: Props) {
  const { onClose, open } = props
  const { getQrCode, getStatus } = useWhatsappApi()
  const [qrCodeImage, setQrCodeImage] = useState(UTILS.BLANK)
  const { isConnected } = useAppSelector((state: RootState) => state.whatsapp)
  const { user } = useAppSelector((state: RootState) => state.auth)
  const isCanceledCompany =
    user?.company?.status === COMPANY_STATUS.CANCELED
  const dispatch = useAppDispatch()

  const handleGetQrCode = useCallback(async () => {
    if (isCanceledCompany) return
    const data = await getQrCode()
    if (data?.connected) {
      dispatch(setIsConnected(true))
    } else if (data.value) {
      setQrCodeImage(data.value)
      dispatch(setIsConnected(false))
    }

    setTimeout(async () => {
      const status = await getStatus()
      if (status === true || status === false) {
        dispatch(setIsConnected(status === true))
        if (status) {
          toast.dismiss(DISCONNECTED_UNKNOWN_NUMBER_TOAST_ID)
        }
      }
      setQrCodeImage(UTILS.BLANK)
    }, 15000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isCanceledCompany])

  useEffect(() => {
    const handleGetStatus = async () => {
      if (isCanceledCompany) return
      const status = await getStatus()
      if (status === false) {
        handleGetQrCode()
      } else if (status === true) {
        toast.dismiss(DISCONNECTED_UNKNOWN_NUMBER_TOAST_ID)
        setQrCodeImage(UTILS.BLANK)
        dispatch(setIsConnected(true))
      }
    }

    handleGetStatus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isCanceledCompany])

  const handleClose = () => onClose()
  const shouldShowQrFlow = isConnected === false
  const shouldShowConnected = isConnected === true

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="xs" fullWidth>
      <Box>
        {shouldShowQrFlow && (
          <>
            <DialogTitle>
              Conecte a sessão não oficial do WhatsApp:
            </DialogTitle>
            <DialogContent>
              {!qrCodeImage && (
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={handleGetQrCode}
                >
                  Obter novo QR code
                </Button>
              )}
              {qrCodeImage && (
                <Box
                  display="flex"
                  justifyContent="center"
                  flexDirection="column"
                  alignItems="center"
                >
                  <Typography variant="subtitle2" mb={1}>
                    Leia o QRCode
                  </Typography>
                  <Typography variant="subtitle1" textAlign="center">
                    Abra o aplicativo do whatsapp e leia o QRCode abaixo para se
                    conectar a esta instância
                  </Typography>
                  <img
                    src={qrCodeImage}
                    width="264px"
                    height="264px"
                    alt="qr code"
                  />
                </Box>
              )}
            </DialogContent>
          </>
        )}
        {shouldShowConnected && (
          <Typography>A sessão não oficial já está conectada</Typography>
        )}
      </Box>
    </Dialog>
  )
}
